import { useCountry } from "./useCountry"
import { useAccount } from "src/hooks/account/useAccount"

export function useAccountCountry() {
  const { data: account } = useAccount()
  return useCountry(account?.country ?? "")
}
